import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import "./Navigation.css";
export default function Navigation({ user }) {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    navigate("/auth");
  };
  return (
    <nav className="navigation-nav">
      <div className="navigation-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
        {/* <img src="" alt="IntelliKlix" className="navigation-logo-img" /> */}
        <span className="navigation-logo-text">IntelliKlix</span>
      </div>
      <div className="navigation-profile">
        <button className="navigation-profile-icon-btn" onClick={() => setShowMenu((prev) => !prev)}>
          <FaUserCircle className="navigation-profile-icon" />
        </button>
        {showMenu && (
          <div className="navigation-profile-dropdown">
            <div className="navigation-profile-dropdown-item navigation-profile-name">{user?.name || "User"}</div>
            <div className="navigation-profile-dropdown-item" onClick={() => navigate('/profile')}>My Profile</div>
            <div className="navigation-profile-dropdown-item">Settings</div>
            <div className="navigation-profile-dropdown-item" onClick={handleLogout}>Logout</div>
          </div>
        )}
      </div>
    </nav>
  );
}
